import script from "./setConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./setConfig.vue?vue&type=script&setup=true&lang=js"

import "./setConfig.vue?vue&type=style&index=0&id=3ef18de8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef18de8"]])

export default __exports__